import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"min-width":"120px"} }
const _hoisted_3 = { style: {"margin-top":"20px"} }
const _hoisted_4 = {
  key: 0,
  style: {"margin-top":"4px","font-size":"12px","color":"#666"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 0,
  style: {"color":"gray","font-size":"13px"}
}
const _hoisted_10 = { style: {"font-size":"14px","line-height":"22px"} }
const _hoisted_11 = { style: {"font-size":"12px","color":"#999","line-height":"18px"} }
const _hoisted_12 = { style: {"display":"flex","gap":"8px","align-items":"flex-start"} }
const _hoisted_13 = { style: {"margin-bottom":"16px"} }
const _hoisted_14 = {
  key: 0,
  style: {"margin-bottom":"12px","color":"#666"}
}
const _hoisted_15 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_16 = { style: {"margin-bottom":"16px"} }
const _hoisted_17 = { style: {"margin-bottom":"16px"} }
const _hoisted_18 = { style: {"max-width":"200px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_19 = { style: {"display":"flex","gap":"8px"} }
const _hoisted_20 = { style: {"display":"flex","gap":"8px"} }
const _hoisted_21 = { style: {"margin-bottom":"16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_EllipsisOutlined = _resolveComponent("EllipsisOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState,
        ref: "searchFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "adsId",
            label: "广告账户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.adsId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.adsId) = $event)),
                placeholder: "广告账户ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "userId",
            label: "用户ID"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_UserSelect, {
                  modelValue: $setup.searchFormState.userId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.userId) = $event)),
                  placeholder: "请选择用户",
                  allowAll: true
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          ($setup.isAdminUser)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                name: "userType",
                label: "用户类型"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: $setup.searchFormState.userType,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.userType) = $event)),
                    style: {"min-width":"120px"},
                    allowClear: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("全部")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("外部")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("内部")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            name: "accountstate",
            label: "账号状态"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.accountState,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchFormState.accountState) = $event)),
                style: {"min-width":"120px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode("使用中")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("已停用")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "3" }, {
                    default: _withCtx(() => [
                      _createTextVNode("已回收")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.addClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysAds.list.add']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.batchAddClick,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("批量添加")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysAds.list.add']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.labelClick,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("备注标签")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysAds.list.update']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_upload, {
                "before-upload": $setup.handleXlsUpload,
                "show-upload-list": false,
                accept: ".xls,.xlsx",
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    loading: $setup.xlsUploadLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上传消耗xls ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }, 8, ["before-upload"])), [
                [_directive_permission, 'sysAds.list.update']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.exportExpendClick,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出消耗xls")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysAds.list.update']
              ]),
              ($setup.hasPermission('sysAds.list.read'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: $setup.recycleRecordClick,
                    style: {"margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("回收记录")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 1200 }
      }, {
        adsId: _withCtx(({ scope }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(
            scope.record.accountState === 3
              ? { textDecoration: 'line-through' }
              : {}
          )
          }, _toDisplayString(scope.record.adsId || "-"), 5)
        ]),
        accountState: _withCtx(({ scope }) => [
          _createVNode(_component_a_tag, {
            color: scope.record.accountState === 1 ? 'green' : scope.record.accountState === 3 ? 'orange' : 'red'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.record.accountState === 1
              ? "使用中"
              : scope.record.accountState === 3
              ? "已回收"
              : "已停用"), 1)
            ]),
            _: 2
          }, 1032, ["color"]),
          (scope.record.accountState === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (scope.record.stopType === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "未知"))
                  : _createCommentVNode("", true),
                (scope.record.stopType === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "客户问题"))
                  : _createCommentVNode("", true),
                (scope.record.stopType === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "技术封禁"))
                  : _createCommentVNode("", true),
                (
              scope.record.stopType === undefined ||
              scope.record.stopType === null
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        userId: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString($setup.userList.filter((val) => val.id === Number(scope.record.userId))
            .length
            ? $setup.userList.filter(
                (val) => val.id === Number(scope.record.userId)
              )[0].name
            : ""), 1),
          (scope.record.userId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " ID:" + _toDisplayString(scope.record.userId), 1))
            : _createCommentVNode("", true)
        ]),
        userType: _withCtx(({ scope }) => [
          (scope.record.userType === 1)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 0,
                color: "blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("内部")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_tag, {
                key: 1,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("外部")
                ]),
                _: 1
              }))
        ]),
        expendAmount: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString(scope.record.expendAmount ?? "-"), 1)
        ]),
        serviceAmount: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString($setup.formatMoney(scope.record.serviceAmount)), 1)
        ]),
        returnAmount: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString($setup.formatMoney(scope.record.returnAmount)), 1)
        ]),
        amount: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString($setup.formatMoney(scope.record.amount)), 1)
        ]),
        control: _withCtx(({ scope }) => [
          _createVNode(_component_a_dropdown, null, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, {
                onClick: (e) => $setup.handleMenuClick(e, scope.record)
              }, {
                default: _withCtx(() => [
                  (scope.record.accountState !== 3 && $setup.hasPermission('sysAds.list.update'))
                    ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "edit" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 编辑 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.hasPermission('sysAds.list.read'))
                    ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "lookBm" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 查看BM ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.hasPermission('sysAds.list.update'))
                    ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "expendList" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 消耗列表 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (scope.record.accountState !== 3 && $setup.hasPermission('sysAds.list.update'))
                    ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "recycle" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 回收 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "text",
                size: "small"
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_EllipsisOutlined)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        pageSize: $setup.pageSize,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        "show-size-changer": "",
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "pageSize", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: $setup.isAdd ? '添加' : '编辑',
      visible: $setup.dislogVisible,
      onCancel: _cache[12] || (_cache[12] = ($event: any) => {$setup.dislogVisible = false; $setup.addLoading = false;}),
      onIsDestroyOnClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.addLoading = false)),
      onConfirm: $setup.confirm,
      loading: $setup.addLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 5, offset: 0 }
        }, {
          default: _withCtx(() => [
            ($setup.isAdd !== 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "账户名称",
                  name: "adsName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: "请输入账户名称",
                      value: $setup.formState.adsName,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.formState.adsName) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.isAdd === 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "广告账户ID",
                  name: "adsId",
                  rules: [{ required: true, message: '请选择广告账户ID!' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: $setup.formState.adsId,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.formState.adsId) = $event)),
                      placeholder: "请选择广告账户ID",
                      "show-search": "",
                      "filter-option": false,
                      onSearch: $setup.handleAdsSearch,
                      onPopupScroll: $setup.handleAdsScroll,
                      onChange: $setup.handleAdsIdChange,
                      onFocus: $setup.handleAdsFocus,
                      onClear: $setup.handleAdsClear,
                      loading: $setup.adsListLoading,
                      "option-label-prop": "label",
                      "allow-clear": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.adsDataList, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.id,
                            value: item.adsId,
                            label: item.adsId
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(item.adsId), 1),
                                _createElementVNode("div", _hoisted_11, _toDisplayString(item.bmBase ? "母BM: " + item.bmBase : "暂无母BM"), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "onSearch", "onPopupScroll", "onChange", "onFocus", "onClear", "loading"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.isAdd === 1 && $setup.isAdminUser)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 2,
                  label: "母BMID",
                  name: "bmName",
                  rules: [{ required: false, message: '请输入母BMID!' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: "",
                      placeholder: "母BMID",
                      value: $setup.formState.bmName,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.formState.bmName) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.isAdd === 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 3,
                  label: "用户",
                  name: "userId",
                  rules: [{ required: true, message: '请选择用户!' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UserSelect, {
                      modelValue: $setup.formState.userId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formState.userId) = $event)),
                      placeholder: "请选择用户"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.isAdd === 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 4,
                  label: "时区"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formState.gmt || '-',
                      disabled: "",
                      placeholder: "选择广告账户ID后自动带出",
                      style: {"background-color":"#f5f5f5"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.isAdd === 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 5,
                  label: "售价"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: 
            $setup.formState.price !== null && $setup.formState.price !== undefined && $setup.formState.price !== ''
              ? Number($setup.formState.price).toFixed(2)
              : '-'
          ,
                      disabled: "",
                      placeholder: "选择广告账户ID后自动带出",
                      style: {"background-color":"#f5f5f5"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.isAdd !== 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 6,
                  label: "账号状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      name: "accountState",
                      value: $setup.formState.accountState,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($setup.formState.accountState) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("使用中")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("已停用")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.formState.accountState === 2)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 7,
                  label: "封禁原因",
                  name: "stopType",
                  rules: [
          {
            required: $setup.formState.accountState === 2,
            message: '请选择封禁原因!',
          },
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: $setup.formState.stopType,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (($setup.formState.stopType) = $event)),
                      placeholder: "请选择封禁原因"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("未知")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("客户问题")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("技术封禁")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "备注",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_select, {
                    value: $setup.remarkArray,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (($setup.remarkArray) = $event)),
                    mode: "tags",
                    placeholder: "请选择备注标签",
                    options: $setup.labelSelectOptions,
                    loading: $setup.labelSelectLoading,
                    "allow-clear": "",
                    style: {"flex":"1"}
                  }, null, 8, ["value", "options", "loading"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "批量添加",
      visible: $setup.batchAddVisible,
      onCancel: _cache[15] || (_cache[15] = ($event: any) => {$setup.batchAddVisible = false; $setup.batchAddLoading = false; $setup.batchAddList = [];}),
      onIsDestroyOnClose: _cache[16] || (_cache[16] = ($event: any) => ($setup.batchAddList = [])),
      loading: $setup.batchAddLoading,
      isFooter: false,
      width: "1100px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: $setup.downloadBatchTemplate,
            style: {"margin-right":"12px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 下载模板 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_upload, {
            "before-upload": $setup.handleBatchFileUpload,
            "show-upload-list": false,
            accept: ".xls,.xlsx"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode("上传Excel")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["before-upload"])
        ]),
        ($setup.batchAddList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 已解析 " + _toDisplayString($setup.batchAddList.length) + " 条数据，请确认后点击「开始添加」 ", 1))
          : _createCommentVNode("", true),
        _createVNode(_component_a_table, {
          columns: $setup.batchAddColumns,
          "data-source": $setup.batchAddList,
          pagination: { pageSize: 5 },
          size: "small",
          "row-key": "key",
          style: {"margin-bottom":"16px"},
          scroll: { y: 300, x: 900 }
        }, null, 8, ["columns", "data-source"]),
        ($setup.batchAddList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_a_button, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => {$setup.batchAddVisible = false; $setup.batchAddList = [];})
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                type: "primary",
                loading: $setup.batchAddLoading,
                onClick: $setup.confirmBatchAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 开始添加 ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "查看BM",
      visible: $setup.bmDislogVisible,
      onCancel: _cache[18] || (_cache[18] = ($event: any) => ($setup.bmDislogVisible = false)),
      isFooter: false,
      width: 800
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_a_form, { layout: "inline" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "BMID" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: $setup.bmIdInput,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (($setup.bmIdInput) = $event)),
                    placeholder: "请输入BMID",
                    style: {"width":"200px"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    type: "primary",
                    onClick: $setup.bindBm,
                    loading: $setup.bindLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("绑定")
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"])), [
                    [_directive_permission, 'sysAds.list.add']
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_XAtable, {
          columns: $setup.bmColumns,
          dataSource: $setup.bmTableData,
          loading: $setup.bmLoading,
          scroll: { x: 600 }
        }, {
          delFlag: _withCtx(({ scope }) => [
            _createVNode(_component_a_tag, {
              color: 
            scope.record.applyStatus === 0
              ? 'orange'
              : scope.record.applyStatus === 1
              ? 'green'
              : 'red'
          
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.record.applyStatus === 0
              ? "待审核"
              : scope.record.applyStatus === 1
              ? scope.record.delFlag === 0
                ? "已绑定"
                : "已解绑"
              : "已驳回"), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          control: _withCtx(({ scope }) => [
            ($setup.hasPermission('sysAds.list.del'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: ($event: any) => ($setup.unbindBm(scope.record)),
                  loading: $setup.unbindLoading === scope.record.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("解绑")
                  ]),
                  _: 2
                }, 1032, ["onClick", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "dataSource", "loading"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_x_dialog, {
      title: "额度递减",
      visible: $setup.subAmountDislogVisible,
      onCancel: _cache[22] || (_cache[22] = ($event: any) => {$setup.subAmountDislogVisible = false; $setup.subAmountLoading = false;}),
      onIsDestroyOnClose: _cache[23] || (_cache[23] = ($event: any) => ($setup.subAmountLoading = false)),
      onConfirm: $setup.subAmountConfirm,
      loading: $setup.subAmountLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.subAmountFormState,
          ref: "subAmountFormRef",
          labelCol: { span: 6, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "广告账户ID",
              name: "adsId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.subAmountFormState.adsId,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (($setup.subAmountFormState.adsId) = $event)),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "剩余金额($)",
              name: "remainingAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.subAmountFormState.remainingAmount,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (($setup.subAmountFormState.remainingAmount) = $event)),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "递减额度",
              name: "wallet",
              rules: [{ required: true, message: '请输入递减额度!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: $setup.subAmountFormState.wallet,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (($setup.subAmountFormState.wallet) = $event)),
                  placeholder: "请输入递减额度",
                  min: 0,
                  max: $setup.subAmountFormState.remainingAmount,
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value", "max"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_alert, {
                  message: "额度递减后资金将退回客户钱包",
                  type: "warning",
                  "show-icon": "",
                  closable: false
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "资金清零",
      visible: $setup.cleanAmountDislogVisible,
      onCancel: _cache[28] || (_cache[28] = ($event: any) => {$setup.cleanAmountDislogVisible = false; $setup.cleanAmountLoading = false;}),
      onIsDestroyOnClose: _cache[29] || (_cache[29] = ($event: any) => ($setup.cleanAmountLoading = false)),
      onConfirm: $setup.cleanAmountConfirm,
      loading: $setup.cleanAmountLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.cleanAmountFormState,
          ref: "cleanAmountFormRef",
          labelCol: { span: 6, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "广告账户ID",
              name: "adsId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.cleanAmountFormState.adsId,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => (($setup.cleanAmountFormState.adsId) = $event)),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "剩余金额($)",
              name: "remainingAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.cleanAmountFormState.remainingAmount,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => (($setup.cleanAmountFormState.remainingAmount) = $event)),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "清零金额($)",
              name: "wallet",
              rules: [{ required: true, message: '请输入清零金额!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: $setup.cleanAmountFormState.wallet,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => (($setup.cleanAmountFormState.wallet) = $event)),
                  placeholder: "请输入清零金额",
                  min: 0,
                  max: $setup.cleanAmountFormState.remainingAmount,
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value", "max"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "FB限额",
              name: "applyType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $setup.cleanAmountFormState.applyType,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => (($setup.cleanAmountFormState.applyType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("自动化")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("手动调整")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_alert, {
                  message: "清零后剩余资金将退回客户钱包",
                  type: "warning",
                  "show-icon": "",
                  closable: false
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "回收账号",
      visible: $setup.recycleDislogVisible,
      onCancel: _cache[30] || (_cache[30] = ($event: any) => {$setup.recycleDislogVisible = false; $setup.recycleLoading = false;}),
      onIsDestroyOnClose: _cache[31] || (_cache[31] = ($event: any) => ($setup.recycleLoading = false)),
      onConfirm: $setup.recycleConfirm,
      loading: $setup.recycleLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.recycleFormState,
          labelCol: { span: 8, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "累计消耗($)" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formatMoney($setup.recycleFormState.expendAmount),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "预计服务费($)" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formatMoney($setup.recycleFormState.serviceAmount),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "已反金额($)" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formatMoney($setup.recycleFormState.returnAmount),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "购买价格($)" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formatMoney($setup.recycleFormState.amount),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_alert, {
                  message: "外部用户因已出售暂时不支持回收",
                  type: "warning",
                  "show-icon": "",
                  closable: false
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: `消耗列表 - ${$setup.currentAdsId || '暂无广告账户ID'}`,
      visible: $setup.expendListDislogVisible,
      onCancel: _cache[34] || (_cache[34] = ($event: any) => ($setup.expendListDislogVisible = false)),
      width: 1000,
      isFooter: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_a_form, { layout: "inline" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "日期" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: $setup.expendListDay,
                    "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => (($setup.expendListDay) = $event)),
                    valueFormat: $setup.dateFormat,
                    placeholder: "请选择日期",
                    allowClear: ""
                  }, null, 8, ["value", "valueFormat"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: $setup.handleExpendListSearch,
                    style: {"margin-right":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    type: "primary",
                    onClick: $setup.addExpendClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("添加")
                    ]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_permission, 'sysAds.list.update']
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_XAtable, {
          columns: $setup.expendListColumns,
          dataSource: $setup.expendListDataWithTotal,
          loading: $setup.expendListLoading,
          scroll: { x: 800 }
        }, {
          day: _withCtx(({ scope }) => [
            _createElementVNode("span", {
              style: _normalizeStyle(scope.record.isTotal ? 'font-weight: bold;' : '')
            }, _toDisplayString(scope.record.day), 5)
          ]),
          expendAmount: _withCtx(({ scope }) => [
            _createElementVNode("span", {
              style: _normalizeStyle(scope.record.isTotal ? 'font-weight: bold;' : '')
            }, _toDisplayString(scope.record.isTotal
              ? (scope.record.expendAmount || 0).toFixed(2)
              : scope.record.expendAmount || 0), 5)
          ]),
          url: _withCtx(({ scope }) => [
            _createVNode(_component_a_tooltip, {
              title: scope.record.url || '-',
              placement: "topLeft"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, _toDisplayString(scope.record.url || "-"), 1)
              ]),
              _: 2
            }, 1032, ["title"])
          ]),
          control: _withCtx(({ scope }) => [
            (!scope.record.isTotal)
              ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: ($event: any) => ($setup.editExpendClick(scope.record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("修改")
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'sysAds.list.update']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "dataSource", "loading"]),
        _createVNode(_component_a_pagination, {
          current: $setup.expendListPageNo,
          "onUpdate:current": _cache[33] || (_cache[33] = ($event: any) => (($setup.expendListPageNo) = $event)),
          onChange: $setup.expendListPageNoChange,
          total: $setup.expendListTotal,
          pageSize: $setup.expendListPageSize,
          hideOnSinglePage: "",
          onShowSizeChange: $setup.expendListShowSizeChange,
          style: {"margin-top":"16px","text-align":"right"}
        }, null, 8, ["current", "onChange", "total", "pageSize", "onShowSizeChange"])
      ]),
      _: 1
    }, 8, ["title", "visible"]),
    _createVNode(_component_x_dialog, {
      title: "添加消耗记录",
      visible: $setup.addExpendDislogVisible,
      onCancel: _cache[38] || (_cache[38] = ($event: any) => {$setup.addExpendDislogVisible = false; $setup.addExpendLoading = false;}),
      onIsDestroyOnClose: _cache[39] || (_cache[39] = ($event: any) => ($setup.addExpendLoading = false)),
      onConfirm: $setup.addExpendConfirm,
      loading: $setup.addExpendLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.addExpendFormState,
          ref: "addExpendFormRef",
          labelCol: { span: 6, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "日期",
              name: "day",
              rules: [{ required: true, message: '请选择日期!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: $setup.addExpendFormState.day,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => (($setup.addExpendFormState.day) = $event)),
                  valueFormat: $setup.dateFormat,
                  placeholder: "请选择日期",
                  style: {"width":"100%"}
                }, null, 8, ["value", "valueFormat"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "消耗($)",
              name: "expendAmount",
              rules: [{ required: true, message: '请输入消耗!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: $setup.addExpendFormState.expendAmount,
                  "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => (($setup.addExpendFormState.expendAmount) = $event)),
                  placeholder: "请输入消耗",
                  min: 0,
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "报表地址",
              name: "url"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_a_input, {
                    value: $setup.addExpendFormState.url,
                    "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => (($setup.addExpendFormState.url) = $event)),
                    placeholder: "请输入报表地址或上传文件",
                    disabled: $setup.addExpendUrlDisabled,
                    style: {"flex":"1"}
                  }, null, 8, ["value", "disabled"]),
                  _createVNode(_component_a_upload, {
                    "before-upload": $setup.handleAddExpendUpload,
                    "show-upload-list": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        loading: $setup.addExpendUploadLoading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 上传 ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }, 8, ["before-upload"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "修改消耗记录",
      visible: $setup.editExpendDislogVisible,
      onCancel: _cache[43] || (_cache[43] = ($event: any) => {$setup.editExpendDislogVisible = false; $setup.editExpendLoading = false;}),
      onIsDestroyOnClose: _cache[44] || (_cache[44] = ($event: any) => ($setup.editExpendLoading = false)),
      onConfirm: $setup.editExpendConfirm,
      loading: $setup.editExpendLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.editExpendFormState,
          ref: "editExpendFormRef",
          labelCol: { span: 6, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "日期",
              name: "day"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.editExpendFormState.day,
                  "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => (($setup.editExpendFormState.day) = $event)),
                  disabled: "",
                  style: {"background-color":"#f5f5f5"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "消耗($)",
              name: "expendAmount",
              rules: [{ required: true, message: '请输入消耗!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: $setup.editExpendFormState.expendAmount,
                  "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => (($setup.editExpendFormState.expendAmount) = $event)),
                  placeholder: "请输入消耗",
                  min: 0,
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "报表地址",
              name: "url"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_a_input, {
                    value: $setup.editExpendFormState.url,
                    "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => (($setup.editExpendFormState.url) = $event)),
                    placeholder: "请输入报表地址或上传文件",
                    disabled: $setup.editExpendUrlDisabled,
                    style: {"flex":"1"}
                  }, null, 8, ["value", "disabled"]),
                  _createVNode(_component_a_upload, {
                    "before-upload": $setup.handleEditExpendUpload,
                    "show-upload-list": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        loading: $setup.editExpendUploadLoading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 上传 ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }, 8, ["before-upload"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "备注标签",
      visible: $setup.labelManageVisible,
      onCancel: _cache[46] || (_cache[46] = ($event: any) => ($setup.labelManageVisible = false)),
      width: 800,
      isFooter: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: $setup.labelAddClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_XAtable, {
          columns: $setup.labelColumns,
          dataSource: $setup.labelTableData,
          loading: $setup.labelLoading,
          scroll: { x: 600 }
        }, {
          control: _withCtx(({ scope }) => [
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => ($setup.labelEditClick(scope.record as any)),
              style: {"margin-right":"8px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("编辑")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_popconfirm, {
              title: "确定要删除吗？",
              onConfirm: ($event: any) => ($setup.labelDelClick(scope.record as any)),
              "ok-text": "确定",
              "cancel-text": "取消"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  danger: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"])
          ]),
          _: 1
        }, 8, ["columns", "dataSource", "loading"]),
        _createVNode(_component_a_pagination, {
          current: $setup.labelPageNo,
          "onUpdate:current": _cache[45] || (_cache[45] = ($event: any) => (($setup.labelPageNo) = $event)),
          onChange: $setup.labelPageNoChange,
          total: $setup.labelTotal,
          "page-size": $setup.labelPageSize,
          hideOnSinglePage: "",
          onShowSizeChange: $setup.labelShowSizeChange,
          style: {"margin-top":"16px","text-align":"right"}
        }, null, 8, ["current", "onChange", "total", "page-size", "onShowSizeChange"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_x_dialog, {
      title: $setup.labelIsAdd ? '添加标签' : '编辑标签',
      visible: $setup.labelFormVisible,
      onCancel: _cache[48] || (_cache[48] = ($event: any) => {$setup.labelFormVisible = false; $setup.labelAddLoading = false;}),
      onIsDestroyOnClose: _cache[49] || (_cache[49] = ($event: any) => ($setup.labelAddLoading = false)),
      onConfirm: $setup.labelConfirm,
      loading: $setup.labelAddLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.labelFormState,
          ref: "labelFormRef",
          labelCol: { span: 5, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "标签名称",
              name: "name",
              rules: [{ required: true, message: '请输入标签名称!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.labelFormState.name,
                  "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => (($setup.labelFormState.name) = $event)),
                  placeholder: "请输入标签名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "选择时间范围",
      visible: $setup.exportExpendVisible,
      onCancel: _cache[51] || (_cache[51] = ($event: any) => {$setup.exportExpendVisible = false; $setup.exportExpendLoading = false;}),
      onIsDestroyOnClose: _cache[52] || (_cache[52] = ($event: any) => ($setup.exportExpendLoading = false)),
      onConfirm: $setup.exportExpendConfirm,
      loading: $setup.exportExpendLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.exportExpendFormState,
          ref: "exportExpendFormRef",
          labelCol: { span: 6, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "时间范围",
              name: "timeRange",
              rules: [{ required: true, message: '请选择时间范围!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: $setup.exportExpendFormState.timeRange,
                  "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => (($setup.exportExpendFormState.timeRange) = $event)),
                  valueFormat: $setup.dateFormat,
                  style: {"width":"100%"}
                }, null, 8, ["value", "valueFormat"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"])
  ], 64))
}